import { Container } from '@pixi/react';
import { useEffect, useRef } from 'react';
import { Spine } from '../../../../../components';

export const JackpotStars: React.FC = () => {
  const ref = useRef<any>();

  useEffect(() => {
    if (ref.current) {
      const spine: Spine = new Spine({ key: 'jackpotBackGroundStars' });
      ref.current.addChild(spine);
      spine.play('idle', true);
    }
  }, []);

  return <Container x={270} y={423} ref={ref} {...({ name: 'JackpotBackGroundStars' } as any)} />;
};
